import React from 'react'
import ProgressBar from '../ProgressBar'
import { pluralize } from '../../utils/util'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CheckMark } from '../../svg/normalSvgs/CheckMark.svg'

function SingleAchievement({ item, width = 'unset' }) {
    const { t } = useTranslation()
    const completed = item.progress === 100
    return (
        <div className={`achievement-container`}>
            <div style={{ minWidth: 114, height: 94 }}>
                <img src={item.image} alt={item.name} key={item.image} />
            </div>
            <div className="achievement-content" style={{ width }}>
                <div className="achievement-title">{item.name}</div>
                <ProgressBar completed={item.progress} backgroundColor="#153c4f" />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div className={`achievement-points`}>
                        {item.rewarding_points} {t(pluralize('point', 10))}
                    </div>
                    {completed && <CheckMark />}
                </div>
            </div>
        </div>
    )
}

export default SingleAchievement
